import React from "react";
import Supervisor from "../images/icon-supervisor.svg";
import Karma from "../images/icon-karma.svg";
import TeamBuilder from "../images/icon-team-builder.svg";
import Calculator from "../images/icon-calculator.svg";

import "./Css/Card.css";

if (window.innerWidth >= 768) {
  import("./Css/CardDesktop.css");
}

const fourCard = () => {
  return (
    <div className="container">
      <section className="heading">
        <h1>Reliable, efficient delivery</h1>
        <h2>Powered by Technology</h2>
        <p>
          Our Artificial Intelligence powered tools use millions of project data
          points to ensure that your project is successful
        </p>
      </section>
      <div className="card-container">
        <div className="card-title card supivsor">
          <h2>Supervisor</h2>
          <span>
            Supervisor Monitors activity to identify project roadblocks
          </span>
          <div className="icon">
            <img
              src={Supervisor}
              alt="icon-supervisor"
              width="24"
              height="24"
            />
          </div>
        </div>
        <div className="card-title card teamBuilder">
          <h2>Team Builder</h2>
          <span>
            Team Builder Scans our talent network to create the optimal team for
            your project
          </span>
          <div className="icon">
            <img
              src={TeamBuilder}
              alt="icon-team-builder"
              width="24"
              height="24"
            />
          </div>
        </div>

        <div className="card-title card karma">
          <h2>Karma</h2>
          <span>
            Karma Regularly evaluates our talent to ensure quality Team Builder
          </span>
          <div className="icon">
            <img src={Karma} alt="icon-karma" width="24" height="24" />
          </div>
        </div>
        <div className="card-title card calculate">
          <h2>Calculator</h2>
          <span>
            Uses data from past projects to provide better delivery estimates
          </span>
          <div className="icon">
            <img
              src={Calculator}
              alt="icon-calculator"
              width="24"
              height="24"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default fourCard;
